export function isMobileBrowser() {
  const ua = (navigator.userAgent || '').toLowerCase()
  return (
    /iphone|ipad|ipod|android|blackberry|mini|windows\sce|palm/i.test(ua) ||
    (window.innerWidth <= 768)
  )
}

export function isIOS() {
  const ua = (navigator.userAgent || '').toLowerCase()
  return /iphone|ipad|ipod/.test(ua) && !window.MSStream
}

export function isAndroid() {
  const ua = (navigator.userAgent || '').toLowerCase()
  return /android|adr/.test(ua)
}



// WEBPACK FOOTER //
// ./src/utils/mobile-detect.js